import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5210 9400 c-4 -3 -13 -342 -20 -755 -6 -412 -13 -751 -15 -753 -2
-2 -29 10 -62 26 -203 103 -505 187 -823 228 -194 25 -559 23 -717 -5 -515
-90 -907 -348 -1084 -712 -109 -223 -148 -562 -90 -781 34 -130 123 -292 213
-388 12 -14 57 -63 98 -110 41 -46 95 -107 120 -134 25 -27 59 -65 75 -83 53
-59 187 -169 280 -229 98 -63 380 -203 461 -229 29 -9 116 -49 195 -88 l144
-72 3 -59 c8 -146 -90 -315 -224 -390 -131 -73 -309 -91 -470 -48 -197 53
-525 215 -778 385 -103 69 -170 64 -216 -16 -28 -48 -98 -163 -256 -422 -203
-332 -205 -336 -216 -397 -6 -34 -7 -63 -2 -68 55 -55 467 -273 649 -342 157
-61 483 -158 683 -204 217 -50 304 -57 612 -51 l285 5 140 35 c223 57 344 110
519 226 118 77 288 242 356 343 25 37 47 68 50 68 3 0 3 -122 2 -272 -4 -264
-3 -272 18 -319 13 -26 28 -50 34 -51 6 -2 351 0 766 5 l755 9 75 38 c41 21
85 46 97 56 l22 19 -59 945 c-32 520 -61 986 -65 1036 l-6 91 178 6 c659 25
1142 180 1445 465 66 62 360 390 453 507 116 144 199 329 236 525 7 36 13 133
13 215 0 136 -3 168 -38 340 -78 386 -189 609 -415 836 -355 355 -898 542
-1646 565 -231 7 -1764 11 -1775 4z m1930 -50 c804 -69 1330 -322 1633 -786
115 -175 204 -428 238 -675 18 -133 7 -360 -24 -489 -23 -94 -37 -130 -95
-250 -40 -82 -142 -215 -216 -280 -22 -19 -53 -48 -70 -63 -102 -94 -340 -219
-544 -286 -318 -105 -611 -147 -1100 -158 -155 -3 -284 -9 -286 -12 -2 -3 3
-100 10 -216 7 -115 22 -372 34 -570 22 -388 43 -746 60 -1025 29 -474 37
-615 34 -619 -3 -4 -1098 -19 -1442 -20 l-193 -1 7 540 c4 297 5 540 1 540 -3
0 -18 -33 -33 -72 -162 -432 -494 -760 -944 -933 -126 -49 -346 -102 -475
-115 -514 -52 -1043 57 -1545 318 -111 58 -297 168 -305 182 -5 7 44 91 213
368 45 74 82 135 82 137 0 2 37 63 82 137 45 73 88 145 97 160 9 16 20 28 25
28 4 0 29 -15 55 -34 137 -100 431 -258 611 -329 192 -76 265 -92 415 -91 209
2 320 40 436 151 142 135 192 421 104 593 -70 136 -191 216 -565 370 -526 217
-808 430 -939 711 -54 116 -75 218 -75 359 1 136 16 244 50 343 191 561 845
912 1602 859 394 -28 706 -108 1034 -264 59 -28 110 -50 112 -47 2 2 9 349 14
771 6 422 14 772 17 778 9 14 1713 5 1885 -10z"/>
<path d="M6543 8662 c-4 -8 1 -142 11 -296 9 -155 23 -396 31 -536 23 -396 36
-593 39 -599 2 -3 123 -3 268 0 288 7 301 9 434 75 133 65 247 209 275 346 33
158 33 221 2 388 -57 302 -231 511 -503 601 -93 30 -187 40 -373 38 -151 -1
-179 -4 -184 -17z m337 -622 c110 -31 185 -76 267 -157 57 -57 82 -92 117
-165 52 -106 78 -199 80 -277 l1 -54 -61 -33 c-102 -57 -194 -75 -401 -81
-138 -4 -186 -3 -198 7 -10 9 -15 31 -15 74 0 33 -9 196 -20 361 -11 165 -20
313 -20 329 l0 29 88 -6 c48 -3 121 -16 162 -27z"/>
<path d="M5187 7708 c-30 -46 -140 -225 -270 -439 l-40 -67 -161 79 c-300 148
-482 206 -671 216 -181 9 -315 -26 -398 -106 -62 -59 -82 -104 -81 -191 0 -60
5 -87 26 -133 50 -107 166 -207 345 -296 80 -40 280 -131 287 -131 15 0 287
-121 365 -162 179 -94 250 -146 377 -272 96 -97 166 -202 207 -311 l22 -60 7
60 c7 65 30 1856 23 1863 -2 2 -19 -20 -38 -50z m-33 -1468 l-6 -134 -31 39
c-52 68 -189 199 -257 246 -139 98 -306 181 -605 304 -77 32 -193 84 -259 117
-117 59 -118 59 -100 80 49 54 189 93 299 84 144 -12 309 -68 558 -191 126
-62 162 -76 194 -73 37 3 40 6 105 113 37 61 67 116 67 123 1 6 5 12 10 12 5
0 13 10 18 23 10 28 16 -564 7 -743z"/>
<path d="M4038 3393 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5250 3350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6024 3165 c0 -71 1 -99 3 -62 2 37 2 96 0 130 -2 34 -3 4 -3 -68z"/>
<path d="M3840 3260 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5620 3240 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5
0 -10 -9 -10 -20z"/>
<path d="M3491 3160 l1 -45 10 34 c6 23 6 37 -1 44 -8 8 -11 -2 -10 -33z"/>
<path d="M4640 3030 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
